export default __webpack_public_path__ + "static/media/UnlockGrey.1374402c.svg";